<template>
  <div class="mv-filter">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <span class="mv-filter-title">Filtering</span>
      <button type="button" class="btn btn-sm btn-link" @click="reset">Reset</button>
    </div>

    <div class="form-field mb-4">
      <label class="m-0">Businesses</label>
      <Multiselect
        v-model="businesses"
        :options="businessesList"
        :max-height="540"
        :limit="300"
        :options-limit="300"
        :multiple="true"
        track-by="id"
        label="name"
        @input="onChange"
        @select="employees = []">
        <template slot="selection" slot-scope="{ values, isOpen }">
          <span class="multiselect__single" v-if="values.length > 1 && !isOpen">{{ values.length }} options selected</span>
          <span class="multiselect__single" v-else-if="values.length === 1 && !isOpen">{{ values[0].name }}</span>
        </template>
        <template slot="option" slot-scope="props">
          <div>
            <span class="d-block text-truncate">{{ props.option.name }}</span>
            <span class="d-block font-size-14 text-truncate">{{ props.option.locationData.address }}</span>
            <span class="d-block font-size-14 text-truncate">{{ props.option.locationData.storeCode }}</span>
          </div>
        </template>
      </Multiselect>
    </div>

    <div class="form-field mb-4">
      <label class="m-0">Workers</label>
      <Multiselect
        v-model="employees"
        :options="employeesListFiltered"
        :max-height="540"
        :limit="300"
        :options-limit="300"
        :multiple="true"
        track-by="id"
        label="fullName"
        @input="onChange">
        <template slot="selection" slot-scope="{ values, isOpen }">
          <span class="multiselect__single" v-if="values.length > 1 && !isOpen">{{ values.length }} options selected</span>
          <span class="multiselect__single" v-else-if="values.length === 1 && !isOpen">{{ values[0].fullName }}</span>
        </template>
      </Multiselect>
    </div>

    <div class="form-field mb-2">
      <div class="d-flex flex-column align-items-start gap-2">
        <AppCheckbox v-model="scheduled" :key="scheduled" @input="onChange">
          <span class="text-capitalize">Scheduled</span>
        </AppCheckbox>
      </div>
    </div>

    <div>
      <p class="mb-2">Moment status</p>
      <div class="d-flex flex-column align-items-start gap-2">
        <AppCheckbox v-for="(val, key) in statuses" v-model="statuses[key]" :key="key" @input="onChange">
          <span class="text-capitalize">{{ key }}</span>
        </AppCheckbox>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import AppCheckbox from '../../components/checkbox'

export default {
  components: { Multiselect, AppCheckbox },
  props: {
    businessesList: { type: Array, default: () => []},
    employeesList: { type: Array, default: () => []}
  },
  data() {
    return {
      businesses: [],
      employees: [],
      scheduled: false,
      statuses: {
        approved: false,
        pending: false,
        rejected: false
      }
    }
  },
  computed: {
    employeesListFiltered() {
      if (!this.businesses.length) return this.employeesList
      return this.employeesList.filter((employee) => {
        let included = false
        for (let i = 0; i < this.businesses.length; i++) {
          if (employee.businessIds.includes(this.businesses[i].id)) {
            included = true
            break
          }
        }

        return included
      })
    }
  },
  methods: {
    reset() {
      this.businesses = []
      this.employees = []
      this.scheduled = false
      this.statuses = {
        approved: false,
        pending: false,
        rejected: false
      }
      this.onChange()
    },
    onChange() {
      const filterData = {
        business: this.businesses.map((b) => b.id),
        employee: this.employees.map((e) => e.id),
        statuses: Object.keys(this.statuses).filter((key) => this.statuses[key])
      }

      if (this.scheduled) {
        filterData.scheduled = true
      }

      this.$emit('onChange', filterData)
    }
  }
}
</script>
